import * as React from "react";
import resumeData from "../../../utils/resumeData";
import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav } from "react-bootstrap";
import CustomButton from "../button/Button";

import TelegramIcon from "@mui/icons-material/Telegram";
import HomeIcon from "@mui/icons-material/Home";
import "./Header.css";

const Header = (props: { location: { pathName: string } }) => {
  return (
    <Navbar expand="lg" sticky="top" className="header">
      <Link to="/" className="header-navlink">
        <Navbar.Brand className="header-home">
          <HomeIcon />
        </Navbar.Brand>
      </Link>

      <Nav className="header-left">
        {/* Resume Link */}
        <Nav.Link as={NavLink} to="/" className="header-link">
          About Me
        </Nav.Link>
        {/* Resume Link */}
        <Nav.Link as={NavLink} to="/resume" className="header-link">
          Resume
        </Nav.Link>
        {/* Portfolio Link */}
        <Nav.Link as={NavLink} to="/portfolio" className="header-link">
          Portfolio
        </Nav.Link>
      </Nav>
      <div className="header-right">
        {Object.keys(resumeData.socials).map((key) => {
          type SocialKey = keyof typeof resumeData.socials;
          const social = resumeData.socials[key as SocialKey];
          return (
            <a href={social.link} target="_blank" rel="noreferrer" key={key}>
              {social.icon}
            </a>
          );
        })}
        <div className="hiremeButton">
          <CustomButton
            text={"Hire Me"}
            href="mailto:evblankenheim@gmail.com"
            icon={<TelegramIcon />}
          />
        </div>
      </div>
    </Navbar>
  );
};

export default Header;
